/**
 * @file ContentList/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */

export const DISPLAY_TYPES = {
    TYPE_LIST: "listItems",
    TYPE_LIST_ORDERED: "listItems orderedList",
    TYPE_DEFAULT: "default",
    DISPLAY_FOUR: "displayFour",
    DISPLAY_FOUR_RIGHT_BORDER: "displayFour displayFourRightBorder",
};
